import { render, staticRenderFns } from "./bBlogView.vue?vue&type=template&id=d91987bc&scoped=true"
import script from "./bBlogView.vue?vue&type=script&lang=js"
export * from "./bBlogView.vue?vue&type=script&lang=js"
import style0 from "./bBlogView.vue?vue&type=style&index=0&id=d91987bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91987bc",
  null
  
)

export default component.exports